import { useContext } from 'react';
import { CheckCircleOutlined } from '@ant-design/icons';
import { KickOffContext } from '../ModalKickOff';

const WhatDoneStep = () => {
  const { nextTaxYearStr } = useContext(KickOffContext);

  const items = [
    'Resets employee Year-to-date figures (YTD).',
    'Applies all relevant statutory changes for the New Tax Year!',
    `Enables payroll processing for the ${nextTaxYearStr} tax year.`,
    'Generates P60s for all current employees.',
    'Generates and submits final FPS & EPS for all Employers.',
  ];

  return (
    <>
      <div
        style={{
          padding: 24,
          border: '1px solid #00795B',
          borderRadius: 10,
        }}
      >
        <div
          style={{ color: '#00795B', fontSize: '1.3rem', marginBottom: 12 }}
        >
          What will be done?
        </div>
        {items.map((item, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              marginBottom: 4,
            }}
          >
            <CheckCircleOutlined style={{ color: '#00795B', fontSize: 18 }} />
            <div>{item}</div>
          </div>
        ))}
      </div>
      <div style={{ margin: '20px 0px' }}>
        You can find the detailed information about the changes{' '}
        <span style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
          in this document.
        </span>
      </div>
    </>
  );
};

export default WhatDoneStep;
